module.exports = function (s) {
  s = s === undefined ? '' : s
  s = s === null ? '' : s
  s = s.toString()
  return s
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/list.js/src/utils/to-string.js
// module id = 305
// module chunks = 0